<ng-form #stepForm="ngForm">
    <!-- billing address -->
    <h3 class="h3">{{'Store Address' | translate}}</h3>

    <address-fieldset class="left"
                      [type]="'billing'"
                      [hideFirstAndLastName]="true"
                      [hidePhone]="true"
                      [form]="stepForm"
                      [data]="data">
    </address-fieldset>

    <!-- business details -->
    <h3 class="m-t-7 h3">{{'Business Details' | translate}}</h3>

    <input-wrap class="block m-t-5 m-t-7-m m-t-7-s overflow-hidden">
        <input class="input p-b-6-m p-b-5-s p-t-7-s"
               type="text"
               name="sole_prop_name"
               required
               sl-input="sole_prop_name"
               [(ngModel)]="data.sole_prop_name"
               [muiInput]="'Sole Proprietor Name' | translate">
    </input-wrap>

    <input-wrap class="block m-t-5 m-t-7-m m-t-7-s overflow-hidden">
        <textarea class="textarea p-b-6-m p-b-5-s p-t-7-s"
                  style="resize:none;"
                  name="partners_name"
                  required
                  sl-input="partners_name"
                  [(ngModel)]="data.partners_name"
                  [muiInput]="'Partnership - Names of Partners' | translate"></textarea>
    </input-wrap>

    <input-wrap class="block m-t-5 m-t-7-m m-t-7-s overflow-hidden">
        <textarea class="textarea p-b-6-m p-b-5-s p-t-7-s"
                  style="resize:none;"
                  name="directors_name"
                  required
                  sl-input="directors_name"
                  [(ngModel)]="data.directors_name"
                  [muiInput]="'Limited Company - Names of Directors' | translate"></textarea>
    </input-wrap>

    <input-wrap class="block m-t-5 m-t-7-m m-t-7-s overflow-hidden">
        <input class="input p-b-6-m p-b-5-s p-t-7-s"
               type="text"
               name="comp_reg_num"
               required
               sl-input="comp_reg_num"
               [(ngModel)]="data.comp_reg_num"
               [muiInput]="'Company Registration Number' | translate">
    </input-wrap>

    <input-wrap class="block m-t-5 m-t-7-m m-t-7-s overflow-hidden">
        <textarea class="textarea p-b-6-m p-b-5-s p-t-7-s"
                  style="resize:none;"
                  name="registered_office"
                  sl-input="registered_office"
                  [(ngModel)]="data.registered_office"
                  [muiInput]="'Registered Office (if different to above)' | translate"></textarea>
    </input-wrap>

    <input-wrap class="block m-t-5 m-t-7-m m-t-7-s overflow-hidden">
        <input class="input p-b-6-m p-b-5-s p-t-7-s"
               type="text"
               name="vat_num"
               required
               sl-input="vat_num"
               [(ngModel)]="data.vat_num"
               [muiInput]="'VAT Number' | translate">
    </input-wrap>

    <input-wrap class="block m-t-5 m-t-7-m m-t-7-s overflow-hidden">
        <input class="input p-b-6-m p-b-5-s p-t-7-s"
               type="text"
               name="website"
               sl-input="website"
               [(ngModel)]="data.website_url"
               [muiInput]="'Website URL' | translate">
    </input-wrap>
</ng-form>